import { QrCode, KeyRound, Hash, FileText, Database, StickyNote, Timer, Dices, BarChart } from 'lucide-react';
import type { Tool } from '@/registry/types';
import { QrGenerator } from './QrGenerator';
import { PasswordGenerator } from './PasswordGenerator';
import { UuidGenerator } from './UuidGenerator';
import { LoremIpsum } from './LoremIpsum';
import { MockData } from './MockData';
import { StickyNotes } from './StickyNotes';
import { TimerStopwatch } from './TimerStopwatch';
import { RandomGenerator } from './RandomGenerator';
import { Barcode } from './Barcode';

export const tinyTools: Tool[] = [
  {
    id: 'qr-generator',
    name: 'QR code generator',
    category: 'tiny',
    description: 'Generate styled QR codes for URLs, Wi-Fi, SMS, or any text.',
    keywords: ['qr', 'qrcode', 'wifi', 'url'],
    icon: QrCode,
    component: QrGenerator,
    featured: true,
    inBrowser: true,
  },
  {
    id: 'barcode-generator',
    name: 'Barcode generator',
    category: 'tiny',
    description: 'Code 128, EAN, UPC, ITF — retail, shipping, and pharma codes.',
    keywords: ['barcode', 'code128', 'ean', 'upc', 'retail', 'shipping'],
    icon: BarChart,
    component: Barcode,
    badge: 'new',
    inBrowser: true,
  },
  {
    id: 'password-generator',
    name: 'Password generator',
    category: 'tiny',
    description: 'Cryptographically strong passwords with entropy meter.',
    keywords: ['password', 'pwd', 'passphrase', 'random', 'secure'],
    icon: KeyRound,
    component: PasswordGenerator,
    featured: true,
    inBrowser: true,
  },
  {
    id: 'uuid-generator',
    name: 'ID generator',
    category: 'tiny',
    description: 'UUIDs, nanoIDs, and ULIDs in bulk.',
    keywords: ['uuid', 'guid', 'nanoid', 'ulid', 'id', 'identifier'],
    icon: Hash,
    component: UuidGenerator,
    inBrowser: true,
  },
  {
    id: 'lorem-ipsum',
    name: 'Lorem ipsum generator',
    category: 'tiny',
    description: 'Placeholder text by paragraph, sentence, or word.',
    keywords: ['lorem', 'ipsum', 'placeholder', 'filler', 'dummy'],
    icon: FileText,
    component: LoremIpsum,
    inBrowser: true,
  },
  {
    id: 'mock-data',
    name: 'Mock data generator',
    category: 'tiny',
    description: 'Realistic user records as JSON, CSV, or SQL.',
    keywords: ['mock', 'fake', 'seed', 'sample', 'data', 'json'],
    icon: Database,
    component: MockData,
    inBrowser: true,
  },
  {
    id: 'sticky-notes',
    name: 'Sticky notes',
    category: 'tiny',
    description: 'Quick scratch notes that persist locally.',
    keywords: ['sticky', 'notes', 'scratch', 'pad'],
    icon: StickyNote,
    component: StickyNotes,
    inBrowser: true,
  },
  {
    id: 'timer-stopwatch',
    name: 'Timer & stopwatch',
    category: 'tiny',
    description: 'Pomodoro timer plus precise stopwatch with laps.',
    keywords: ['timer', 'stopwatch', 'pomodoro', 'clock'],
    icon: Timer,
    component: TimerStopwatch,
    inBrowser: true,
  },
  {
    id: 'random-generator',
    name: 'Random generator',
    category: 'tiny',
    description: 'Numbers, picks, dice, and coin flips.',
    keywords: ['random', 'dice', 'coin', 'pick', 'number'],
    icon: Dices,
    component: RandomGenerator,
    inBrowser: true,
  },
];
